import { ScreenSizes } from '../types/index.js';

function checkIsPrimitive(value) {
    return value === null || typeof value !== 'object' && typeof value !== 'function';
}
const isResponsiveElement = (value, screeSize) => typeof value === 'object' && value !== null && screeSize in value;
function getCSSPropDefaultValue(CSSProp) {
    if (!CSSProp)
        return undefined;
    const { XXL, XL, LG, MD, SM, XS, } = ScreenSizes;
    return isResponsiveElement(CSSProp, XXL) && CSSProp[XXL]
        || isResponsiveElement(CSSProp, XL) && CSSProp[XL]
        || isResponsiveElement(CSSProp, LG) && CSSProp[LG]
        || isResponsiveElement(CSSProp, MD) && CSSProp[MD]
        || isResponsiveElement(CSSProp, SM) && CSSProp[SM]
        || isResponsiveElement(CSSProp, XS) && CSSProp[XS]
        || CSSProp;
}
function computeResponsiveness(size) {
    const defaultValue = getCSSPropDefaultValue(size);
    const expectedProperties = checkIsPrimitive(size) ? undefined : Object.keys(defaultValue).reduce((acc, key) => {
        acc[key] = undefined;
        return acc;
    }, {});
    const { Default, XXL, XL, LG, MD, SM, XS, XXS, } = ScreenSizes;
    return {
        [Default]: { value: defaultValue },
        [XXL]: { value: isResponsiveElement(size, ScreenSizes.XXL) ? size[XXL] : expectedProperties },
        [XL]: { value: isResponsiveElement(size, ScreenSizes.XL) ? size[XL] : expectedProperties },
        [LG]: { value: isResponsiveElement(size, ScreenSizes.LG) ? size[LG] : expectedProperties },
        [MD]: { value: isResponsiveElement(size, ScreenSizes.MD) ? size[MD] : expectedProperties },
        [SM]: { value: isResponsiveElement(size, ScreenSizes.SM) ? size[SM] : expectedProperties },
        [XS]: { value: isResponsiveElement(size, ScreenSizes.XS) ? size[XS] : expectedProperties },
        [XXS]: { value: isResponsiveElement(size, ScreenSizes.XXS) ? size[XXS] : expectedProperties },
    };
}

export { computeResponsiveness, getCSSPropDefaultValue };
